import React, { Component } from 'react'
export default class ChildCompany extends Component {
  constructor(props) {
    super(props)
    this.state = {
      block: [
        {
          title: '青矩工程顾问有限公司',
          content: '（简称“青矩顾问”），创立于2005年，是国内领先的综合工程咨询服务机构，已连续十年蝉联工程造价咨询行业全国前三甲。青矩顾问拥有完善的业务标准、优秀的专业团队、丰富的项目经验、先进的信息系统，以及顶级的执业资质、信用评级和行业排名，这些青矩特质铸就了青矩专业、优质、可靠的服务品质。',
          imgPath: require('img/ecology/pic1.png'),
          imgHDPath: `${require('img/ecology/pic1.png')} 1x,${require('img/ecology/pic1@2x.png')} 2x,${require('img/ecology/pic1@3x.png')} 3x`,
          attachURL: '/'
        },
        {
          title: '北京百工驿科技有限公司',
          content: '（简称“百工驿”）是青矩技术旗下专业从事工程管理科技生态圈建设和推广应用的国家高新技术企业，是一家为工程咨询行业企业提供标准化、智能化工程咨询解决方案，同时为行业从业者提供工程知识学习、社交互动、业务协作及人才服务等综合型工程研究与应用落地的互联网平台服务商。',
          imgPath: require('img/ecology/pic2.png'),
          imgHDPath: `${require('img/ecology/pic2.png')} 1x,${require('img/ecology/pic2@2x.png')} 2x,${require('img/ecology/pic2@3x.png')} 3x`,
          attachURL: '/'
        },
        {
          title: '青矩译筑科技（上海）有限公司',
          content: '（简称“青矩译筑”）青矩译筑成立于2014年，专注工程建设领域数字化应用，致力于建设实用的智慧建筑数据服务平台，已通过高新技术企业、双软认证，并拥有60余项发明专利和软件著作权。公司主营译筑云三维数智中台、译筑云智慧建造平台、工程数字化一站式解决方案。平台安全性、稳定性获得了行业内的广泛认可，实现单个企业级用户4000+个项目在线运行，25+万名用户在线协同，5万+个模型在线承载。',
          imgPath: require('img/ecology/pic3.png'),
          imgHDPath: `${require('img/ecology/pic3.png')} 1x,${require('img/ecology/pic3@2x.png')} 2x,${require('img/ecology/pic3@3x.png')} 3x`,
          attachURL: '/'
        },
        {
          title: '广州青矩数字科技有限责任公司',
          content: '（简称“青矩数科”）青矩数科成立于2024年，专注工程造价数智化研究与实践，已申请获取10余项发明专利及软件著作权。公司主要从事工程造价大数据平台建设与造价智能化应用产品研发，致力于用互联网思维与科学技术让工程造价工作变得简单、智能、有价值。',
          imgPath: require('img/ecology/pic6.png'),
          imgHDPath: `${require('img/ecology/pic6.png')} 1x,${require('img/ecology/pic6@2x.png')} 2x,${require('img/ecology/pic6@3x.png')} 3x`,
          attachURL: '/'
        },
        {
          title: '青矩未来式智能科技（北京）有限公司',
          content: '（简称“青矩未来”)，是一家专注于“工程+AI”垂直领域AI应用落地，深度融合工程咨询行业经验与前沿AI技术、汇聚资深工程专家与智能体研发团队及行业用户生态，构建覆盖全场景的工程咨询AI应用体系。依托青矩Agent平台，公司已推出通用大模型聚合、工程咨询场景智能体、工程AI智慧审计工具等核心产品。通过技术创新与场景深耕，致力于成为工程咨询行业AI转型的标杆推动者。',
          imgPath: require('img/ecology/pic_qjwl.png'),
          imgHDPath: `${require('img/ecology/pic_qjwl.png')} 1x,${require('img/ecology/pic_qjwl@2x.png')} 2x,${require('img/ecology/pic_qjwl@3x.png')} 3x`,
          attachURL: '/'
        }
        // {
        //   title: '北京天职信息技术有限公司',
        //   content: '简称“天职信息”，是建设项目管理系统、交易平台、数据中心的设计、开发维护服务机构。公司熟悉会计师事务所、管理咨询公司、评估公司、税务公司等企业管理及运作模式。近年来先后研发会计师事务所综合管理平台、造价咨询企业集成工作平台、全过程造价管理系统、资产评估企业项目管理系统等信息化产品，并已陆续推向市场。',
        //   imgPath: require('img/ecology/pic4.png'), imgHDPath: `${require("img/ecology/pic4.png")} 1x,${require("img/ecology/pic4@2x.png")} 2x,${require("img/ecology/pic4@3x.png")} 3x`, attachURL: "/"
        // },
        // {
        //   title: '北京网证科技有限公司',
        //   content: '简称“网证科技”，致力于企业、专业机构及银行间的互联网产品的开发及运营。旗下首推的产品「电子函证」，利用独特身份验证技术和授权过程以及严格的用户访问控制和监控，实现传统的银行询证、企业往来询证、律师询证等业务的互联网实现。公司于2016年获得“天使投资”投资。',
        //   imgPath: require('img/ecology/pic5.png'), imgHDPath: `${require("img/ecology/pic5.png")} 1x,${require("img/ecology/pic5@2x.png")} 2x,${require("img/ecology/pic5@3x.png")} 3x`, attachURL: "/"
        // },
      ]
    }
  }
  render() {
    return (
      <div className="childCompany-container">
        <p className="ecology-title">子公司</p>
        {this.state.block.map((item, index) => (
          <div className="child-block" key={index}>
            <p className="sub-title">{item.title}</p>
            <div className="sub-box">{item.content}</div>
            <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
          </div>
        ))}
      </div>
    )
  }
}
